<div class="grid-container padding-y-4">
  <div class="grid-col-12 mobile-lg:grid-col-12">
    <ul class="usa-button-group">
      <li class="usa-button-group__item">
        <button type="button" class="usa-button" (click)="onSingleShipmentReportClicked()" >
          Single Shipment Report
        </button>
      </li>
      <li class="usa-button-group__item">
        <button type="button" class="usa-button" (click)="onBatchShipmentReportClicked()" >
          Batch Shipment Report
        </button>
      </li>
      <li class="usa-button-group__item">
        <button type="button" class="usa-button" (click)="onComprehensiveShipmentReportClicked()" >
          Comprehensive Report
        </button>
      </li>
    </ul>
  </div>
</div>
<!--TODO uncomment the below in future once XTOS delinquency is ready-->
<!--<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col-5">
      <legend class="usa-legend usa-legend&#45;&#45;large">XTOS Shipment Report Status</legend>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-7 desktop:grid-col-7 text-right margin-x-auto margin-y-auto display-flex flex-column flex-align-end">
      <ul class="usa-button-group">
        <li class="usa-button-group__item">
          <button type="button" class="usa-button" (click)="onSingleShipmentReportClicked()" >
            Single Shipment Report
          </button>
        </li>
        <li class="usa-button-group__item">
          <button type="button" class="usa-button" (click)="onBatchShipmentReportClicked()" >
            Batch Shipment Report
          </button>
        </li>
        <li class="usa-button-group__item">
          <button type="button" class="usa-button" (click)="onComprehensiveShipmentReportClicked()" >
            Comprehensive Report
          </button>
        </li>
      </ul>
    </div>
  </div>

  <form id="iffdelindReportGroup" role="form" [formGroup]="xtosDelinqReport" (ngSubmit)="getXtosDelinqReport()">
    <div class="grid-row grid-gap">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="reportingYrSelect" class="usa-label">Reporting Calender Year<abbr title="required"
                                                                                      class="usa-hint usa-hint&#45;&#45;required">*</abbr></label>
        <select id="reportingYrSelect" class="usa-select width-full" formControlName='reportingYrSelect' (change)="getDelinqEmailStatus();">
          <option hidden value=''>Choose...</option>
          <option *ngFor="let reportingYrSingle of reportingYrList" [value]="reportingYrSingle">
            {{reportingYrSingle}}</option>
        </select>
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="reportingQtrSelect" class="usa-label">Reporting Quarter<abbr title="required"
                                                                                 class="usa-hint usa-hint&#45;&#45;required">*</abbr></label>
        <select id="reportingQtrSelect" class="usa-select width-full" formControlName='reportingQtrSelect' (change)="getDelinqEmailStatus();">
          <option hidden value=''>Choose...</option>
          <option *ngFor="let qtr of this.printQtrList" [value]="qtr.value">{{qtr.name}}</option>
        </select>
      </div>

    </div>
    <div class="grid-row grid-gap padding-top-2 padding-bottom-4">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <button type="button" class="usa-button" type="submit" [disabled]="this.xtosDelinqReport.invalid">Search</button>
      </div>
    </div>
    &lt;!&ndash;<div class="grid-row grid-gap padding-bottom-205" *ngIf="rowData && rowData.length>0">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <img src="assets/uswds/img/usa-icons/file_download.svg" alt="user_icon"> Right click on the report and select the appropriate options to export.
      </div>
    </div>
    <div>
      <ag-grid-angular class="ag-theme-alpine" [columnDefs]="columnsDefs" [gridOptions]="gridOptions" [rowData]="rowData" [suppressDragLeaveHidesColumns]="true" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>&ndash;&gt;
  </form>

</div>-->
